import {RouteObject} from 'react-router-dom';
import {ProtectedRoute} from '../auth/require-authorization';
import {AllRoles} from '../navigation/links';
import {ROUTES} from '../routes';
import {EmailLogListing} from './email-log-listing';
import {EmailLogView} from './email-log-view';

export const EmailLogRoutes: RouteObject = {
  path: ROUTES.ADMIN.EMAIL_LOG.path,
  element: <ProtectedRoute role={AllRoles} />,
  children: [
    {
      path: ROUTES.ADMIN.EMAIL_LOG.INDEX.path,
      element: <EmailLogListing />,
    },
    {
      path: ROUTES.ADMIN.EMAIL_LOG.DETAIL.path,
      element: <EmailLogView />,
    },
  ],
};
